import React, { useState, useRef, useEffect } from "react";
import { Globe, Check } from "lucide-react";
import { useLang } from "../i18n/LanguageContext";

export default function LangSwitch() {
  const { lang, setLang, langs } = useLang();
  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    const onClick = (e) => { if (ref.current && !ref.current.contains(e.target)) setOpen(false); };
    document.addEventListener("mousedown", onClick);
    return () => document.removeEventListener("mousedown", onClick);
  }, []);

  return (
    <div ref={ref} className="fixed left-4 bottom-24 z-[70]" data-no-i18n data-testid="lang-switch">
      {open && (
        <div className="mb-2 w-44 rounded-2xl bg-white shadow-2xl ring-1 ring-black/10 overflow-hidden animate-in fade-in slide-in-from-bottom-2" data-testid="lang-switch-menu">
          {langs.map((l) => (
            <button
              key={l.code}
              data-testid={`lang-opt-${l.code}`}
              onClick={() => { setLang(l.code); setOpen(false); }}
              className={`w-full flex items-center justify-between px-4 py-2.5 text-sm font-semibold transition-colors ${
                lang === l.code ? "bg-[#FBF0CE] text-[#0A1C30]" : "text-[#0A1C30] hover:bg-[#FAF8F1]"
              }`}
            >
              <span>{l.label}</span>
              {lang === l.code ? <Check className="w-4 h-4 text-[#B99B2E]" /> : <span className="text-xs text-[#9AA4B4]">{l.code}</span>}
            </button>
          ))}
        </div>
      )}
      <button
        onClick={() => setOpen((o) => !o)}
        data-testid="lang-switch-btn"
        className="flex items-center gap-2 rounded-full bg-[#0A1C30] text-white px-4 py-2.5 text-sm font-bold shadow-xl hover:bg-[#12294a] transition-colors ring-1 ring-white/10"
        title="Idioma / Language"
      >
        <Globe className="w-4 h-4 text-[var(--gold)]" />
        <span>{lang}</span>
      </button>
    </div>
  );
}
